.overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;

    background-color: rgba(var(--bs-white-rgb), 0.3);
    backdrop-filter: blur(30px) brightness(0.2);

    text-shadow: 0 1px 3px rgb(0 0 0 / 60%);
    color: white;

    display: grid;
    place-content: center;
    place-items: center;
    gap: 1rem;

    z-index: 1;

    animation: fadeIn 280ms ease-out;
}

@keyframes fadeIn {
    0% {
        opacity: 0;
    }
}
